import {Injectable} from "@angular/core";
import {BusService} from "./bus.service";

@Injectable()
export class PreloaderService {
  private requestCount: number = 0;


  constructor(private busService: BusService) {
  }


  show() {
    //console.log('show');
    if (this.requestCount > 0) {
      return;
    }
    this.requestCount++;

    this.busService.emitPreloaderIsVisible(true);
  }


  hide() {
    //console.log('hide');
    this.requestCount--;
    if (this.requestCount > 0) {
      return;
    }

    this.requestCount = 0;
    this.busService.emitPreloaderIsVisible(false);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/preloader.service.ts